export default __webpack_public_path__ + "images/call-to-action-bg.png?6e052465785e8dadff4b774d09693eda";